import { useState, useEffect } from "react";

// True on phone-width screens, so pickers can open as a bottom sheet instead of a dropdown.
const QUERY = "(max-width: 576px)";

const useIsMobile = () => {
  const get = () => typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const mql = window.matchMedia?.(QUERY);
    if (!mql) return undefined;
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener?.("change", handler);
    return () => mql.removeEventListener?.("change", handler);
  }, []);
  return isMobile;
};

export default useIsMobile;
